import { Link, useLocation } from 'react-router'
import { useEntities } from '../context/EntitiesContext'

interface PromptPageNavigationProps {
  promptId: string
}

const TABS: Array<{ path: string, label: string, completionOnly?: boolean }> = [
  { path: '', label: 'Variants' },
  { path: '/datasets', label: 'Datasets', completionOnly: true },
  { path: '/simulations', label: 'Simulations', completionOnly: true },
  { path: '/deployments', label: 'Deployments' },
  { path: '/settings', label: 'Settings' },
]

export function PromptPageNavigation ({ promptId }: PromptPageNavigationProps) {
  const location = useLocation()
  const { prompts } = useEntities()
  const isDecision = prompts.find(p => p.id === promptId)?.type === 'decision'

  return (
    <div className="mb-4 border-b border-gray-700">
      <nav className="flex gap-4">
        {TABS.filter(tab => !isDecision || !tab.completionOnly).map(tab => {
          const to = `/prompts/${promptId}${tab.path}`
          return (
            <Link
              key={tab.label}
              to={to}
              className={`px-3 py-1.5 transition-colors ${
                location.pathname === to
                  ? 'text-white border-b-2 border-blue-500'
                  : 'text-gray-400 hover:text-white'
              }`}
            >
              {tab.label}
            </Link>
          )
        })}
      </nav>
    </div>
  )
}
